module.exports = __webpack_public_path__ + "static/beach-24c3e081990a7941b4e3093a5caf4f60.mp4";